import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../shared/Services/authentication.service';
import {Helper} from '../../helpers/helper.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ResetPassword} from '../../shared/Models/ResetPassword';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  private token: string;
  resetPasswordModel: ResetPassword = new ResetPassword();


  constructor(private auth: AuthenticationService, public helper: Helper, private router: Router, private route: ActivatedRoute, private translate: TranslateService) {
  }


  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (Helper.isDefined(params['token'])) {
        this.token = params['token'];
      }
    });
      document.querySelector('body').setAttribute('themebg-pattern', 'theme1');
  }

  submitResetPassword() {
    this.auth.resetPassword(this.resetPasswordModel, this.token).subscribe(res => {
      this.router.navigateByUrl('/login');
    });
  }

}
